import { Injectable } from '@angular/core';
import { Unit, ValueAndUnit } from '../models/misc.model';

@Injectable({
  providedIn: 'root',
})
export class DateDifferenceService {
  /**
   * Computes the difference between the two given ISO date strings,
   * rounded to the highest non-zero unit,
   * for example { value: 4, unit: 'day' } if the delta is 4.23 days
   *
   * We don't handle the case where a DST change occured between the given dates,
   * nor do we mind that the switch between 30 days and 1 month occurs at 30,42 days
   */
  compactDateDifference(d1, d2): ValueAndUnit {
    const s = Math.floor((new Date(d2).getTime() - new Date(d1).getTime()) / 1000);
    const terms = [
      { value: Math.floor(s / (60 * 60 * 24 * 365)), unit: Unit.Year },
      { value: Math.floor(s / (60 * 60 * 24 * 30.42)), unit: Unit.Month },
      { value: Math.floor(s / (60 * 60 * 24)), unit: Unit.Day },
      { value: Math.floor(s / (60 * 60)), unit: Unit.Hour },
      { value: Math.floor(s / 60), unit: Unit.Minute },
      { value: s, unit: Unit.Second },
    ];
    for (const term of terms) {
      if (term.value > 0) {
        return term;
      }
    }
    return terms[terms.length - 1]; // {0, second} in this case
  }

  compactDateDifferenceToNow(d) {
    return this.compactDateDifference(d, new Date().toISOString());
  }
}
